<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" @click="openModel('cangku')" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table :data="cangkuList" style="width: 100%" size="mini" :max-height="maxHeight" row-key="id" :tree-props="{ children: 'child', hasChildren: 'hasChildren' }"  @current-change="handleCurrentChange">
				<el-table-column width="150">
					<template slot="header" slot-scope="scope">编号</template>
					<template slot-scope="scope">{{scope.$index}}</template>
				</el-table-column>
				<el-table-column width="320">
					<template slot="header" slot-scope="scope">仓库名称</template>
					<template slot-scope="scope">{{scope.row.name}}</template>
				</el-table-column>
				<el-table-column width="100" align="center" >
					<template slot="header" slot-scope="scope">最大容量</template>
					<template slot-scope="scope">{{scope.row.zdrl}}</template>
				</el-table-column>
				<el-table-column width="130" align="center" >
					<template slot="header" slot-scope="scope">储存方式</template>
					<template slot-scope="scope">
						<el-button type="info" plain size="mini" v-if="scope.row.ccfs == 0">无</el-button>
						<el-button type="primary" plain  size="mini" v-else>{{scope.row.ccfsdata.name}}</el-button>
					</template>
				</el-table-column>
				<el-table-column width="260">
					<template slot="header" slot-scope="scope">位置</template>
					<template slot-scope="scope">{{scope.row.wz}}</template>
				</el-table-column>
				<el-table-column align="center" fixed="right" width="220">
					<template slot="header" slot-scope="scope">操作</template>
					<template slot-scope="scope">
						<el-button type="success" size="mini" @click="openModel('cangkus',scope.row)" v-if="scope.row.jb != 5">添加</el-button>
						<!-- <el-button type="primary" size="mini" @click="openModel('cangku',scope.row)">查看</el-button> -->
						<el-button type="primary" size="mini" @click="openModel('cangku',scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" 	:total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="编辑信息" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<div style="width: 50%;">
					<el-form v-if="preUrl ==='cangku' " ref="form" :model="form.cangku" label-width="80px">
						<el-form-item label="* 仓库名称">
							<el-input v-model="form.cangku.name" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="最大容量">
							<el-input-number v-model="form.cangku.zdrl" size="mini" style="width: 90%;" :precision="2"></el-input-number>
						</el-form-item>
						<el-form-item label="存储方式" v-if="form.cangku.jb == 1">
							<el-select v-model="form.cangku.ccfs" filterable style="width: 90%;" size="mini">
							    <el-option v-for="item in ccfslist" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 50%;">
					<el-form v-if="preUrl ==='cangku' " ref="form" :model="form.cangku" label-width="80px">
						<el-form-item :label="syjOrdq == 0 ? '上一级' : '当前等级'">
							<div v-if="form.cangku.syj == 0">最顶层</div>
							<div v-else>{{form.cangku.wz}}</div>
							<!-- <el-select v-model="form.cangku.syj" placeholder="请选择" size="mini">
							    <el-option
							      v-for="item in syjck"
							      :key="item.id"
							      :label="item.name"
							      :value="item.id">
							    </el-option>
							  </el-select> -->
						</el-form-item>
						<el-form-item label="位置级别">
							<el-select v-model="form.cangku.jb" placeholder="请选择" size="mini" :disabled="true">
							    <el-option
							      v-for="item in wzjb"
							      :key="item.id"
							      :label="item.name"
							      :value="item.id">
							    </el-option>
							  </el-select>
						</el-form-item>
					</el-form>
				</div>
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				cangku: {
				},
			},
			createModel: false,
			syjck:[],
			dialogType: "cangku",
			preUrl: "cangku", //api
			dialogId: 0,
			syjOrdq:0,
			cangkuList:[],
			wzjb:[
				{
					id:0,
					name:'仓库'
				},
				{
					id:1,
					name:'库'
				},
				{
					id:2,
					name:'区'
				},
				{
					id:3,
					name:'列'
				},
				{
					id:4,
					name:'层'
				},
				{
					id:5,
					name:'板'
				}
			],
			maxHeight: 0,
			ectj:0,
			ccfslist:[]
		};
		
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 240; //300是页面中除了表格外其他组件的高度
		});
		
	},
	created(){
		this.axios.get('/admin/ccfs/1', { token: true }).then(res => {
			this.ccfslist = res.data.data.list;
		});
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`
		},
		// 处理列表结果
		getListResult(e) {
			this.cangkuList = e.list
			this.axios.get('/admin/cangkus',{
				token: true
			}).then(res => {
				this.syjck = res.data.data
			})
			
		},
		openModel(type, item = false) {
			this.syjOrdq = 0
			// 初始化表单
			switch (type) {
				// 创建/编辑
				case 'cangku':
					this.syjOrdq = 1
					if (!item) { // 创建
						this.form.cangku = {
							id:'',
							name: "",
							zdrl: 2.5,
							syj:'',
							wz:'',
							jb:0,
							ck:0,
							ccfs:0
						}
						this.dialogId = 0
					} else { // 编辑
						this.form.cangku = {
							name: item.name,
							zdrl: item.zdrl,
							syj:item.syj,
							wz:item.wz,
							jb:item.jb,
							ck:item.ck,
							ck_k:item.ck_k,
							ck_q:item.ck_q,
							ck_h:item.ck_h,
							ck_l:item.ck_l,
							ccfs:item.ccfs
						}
						this.dialogId = item.id
					}
					break;
					// 添加
				case 'cangkus':
					this.form.cangku = {
						id:'',
						name: "",
						zdrl: "",
						syj:item.id,
						wz:item.wz,
						jb:item.jb+1,
						ck:item.ck,
						ck_k:item.ck_k,
						ck_q:item.ck_q,
						ck_h:item.ck_h,
						ck_l:item.ck_l,
						ccfs:item.ccfs
					}
					this.dialogId = 0
					this.ectj = 1
					break;
			}
			// 打开dialog
			console.log(this.form.cangku)
			this.createModel = true;
		},
		submit() {
			let f = this.form.cangku
			let e = {
				name: f.name,
				syj:f.syj,
				zdrl: f.zdrl,
				cjr:this.user.id,
				jb:f.jb,
				ck:f.ck,
				ck_k:f.ck_k,
				ck_q:f.ck_q,
				ck_h:f.ck_h,
				ck_l:f.ck_l,
				ccfs:f.ccfs
			}
			if(this.ectj == 1){
				e.wz = f.wz
				if(f.jb == 1){
					e.ck = f.syj
				}else if(f.jb == 2){
					e.ck_k = f.syj
				}else if(f.jb == 3){
					e.ck_q = f.syj
				}else if(f.jb == 4){
					e.ck_h = f.syj
				}else if(f.jb == 5){
					e.ck_l = f.syj
				}
				
			}
			if(e.syj != 0){
				e.wz = f.wz + '-' + f.name
			}else{
				e.wz = f.name
			}
			this.addOrEdit(e, this.dialogId);
			this.createModel = false;
			this.getListResult()
			this.ectj = 0
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style></style>
